var map = {
	"./Iron_buddha_tea.jpg": 2929,
	"./iron_buddha_tea_cup.jpg": 9330,
	"./iron_buddha_tea_leaves-raw.jpg": 7104,
	"./iron_buddha_tea_leaves.jpg": 1806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2101;